define("shared/helpers/-private/intl/t", ["exports", "@ember/application", "ember-intl/helpers/t"], function (_exports, _application, _t) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"@ember/application",0,"ember-classic-decorator",0,"ember-intl/helpers/t"eaimeta@70e063a35619d71f
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  class T extends _t.default {
    constructor() {
      super(...arguments);
      _defineProperty(this, "allowEmpty", true);
    }
    format(key, options) {
      try {
        return this.intl.t(key, options);
      } catch (error) {
        const errors = (0, _application.getOwner)(this).lookup('service:errors');
        if (errors) {
          errors.log(error, {
            key,
            options
          }, 'critical');
        }
      }
    }
  }
  _exports.default = T;
});